import { Checkbox, ConfigProvider } from "antd";

export default function CheckboxGroupComponent({
  purpose,
  options,
  selectedOptions,
  onChangeHandler,
}) {
  
  const CheckboxGroup = Checkbox.Group;

  const onChangeOption = (e) => {
    onChangeHandler(purpose, e);
  }

  return (
    <div className="flex flex-row w-full gap-14">
      <ConfigProvider
        theme={{
          token: {
            colorPrimary: "#572D86",
            colorPrimaryBorder: "#572D86",
            colorPrimaryHover: "#572D86",
            controlOutline: "#572D86",
            colorBorder: "#572D86",
          },
        }}
      >
        <CheckboxGroup
          options={options.map((option) => ({
            // label: option,
            label: (
              <span
                style={{
                  opacity: 1, 
                }}
              >
                {option}
              </span>
            ),
            value: option,
            style: {
              opacity: 1,
            },
          }))}
          value={selectedOptions}
          onChange={onChangeOption}
        />
      </ConfigProvider>
    </div>
  );
}
